import React, { Component } from 'react';
import fastdom from 'fastdom';
import get from 'lodash/get';
import _ from 'lodash';
import throttle from 'lodash/throttle';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import classNames from 'classnames';
import { SortTypes, SortHeader } from './SortHeader/SortHeader';
import PlayerCell from './PlayerCell';
import dictionary from '../../../lib/dict.json';
import {
  selectControlsState,
  toggleSelectedPlayer,
} from '../../../store/reducers/tableControls';
import { selectTracking } from '../../../store/reducers/tracking';
import { DESKTOP, TABLET } from '../../../store/actions/browser.types';
import DataTablePropTypes from './DataTable.proptypes';
import classes from './DataTable.css';

/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */

const mapStateToProps = state => ({
  collapsed: selectControlsState(state).collapsed,
  selectedPlayers: selectControlsState(state).selectedPlayers,
  tracking: selectTracking(state),
  mediaType: state.browser.mediaType,
});
const actions = {
  toggleSelectedPlayer,
};
export class DataTable extends Component {
  static propTypes = DataTablePropTypes;
  static defaultProps = {
    language: 'en',
    data: [],
    tracking: {},
    selectedPlayers: [],
    teams: [],
    colGroups: [
      {
        name: '',
        columns: [''],
      },
    ],
    track: false,
    compare: false,
    injury: false,
    showAnalysis: false,
    showRookie: false,
    showTrackedPlayers: false,
    selectedLeague: null,
    initialSortColumn: 'FFPTS',
    sortAscending: false,
    noRank: false,
    showAt: false,
    showLinks: true,
    noStars: false,
  };

  state = {
    players: {},
    allColumns: [],
    fixedColumns: [],
    currentSort: {},
    matrix: [],
    nested: false,
    windowWidth: 0,
    activeCol: 0,
    hideMoreContent: null,
  };

  componentDidMount = () => {
    const { colGroups, mediaType, initialSortColumn, sortAscending, data, noRank } = this.props;
    const initialSortDir = sortAscending ? SortTypes.ASC : SortTypes.DESC;
    const allColumns = [];
    let fixedColumns = [];
    const currentSort = {};
    this.fixedElements = [];
    this.processMatrix(data, initialSortColumn, initialSortDir);
    colGroups.forEach(group => {
      group.columns.forEach(col => {
        allColumns.push(col);
        // TEST setting initial sort for each column
        // currentSort[col] = !sortAscending ? SortTypes.ASC : SortTypes.DESC;
      });
      if (group.fixedColumns !== undefined) {
        group.fixedColumns.map(col => fixedColumns.push(col));
      } else {
        fixedColumns = [...allColumns];
      }
    });
    this.setState({ allColumns, fixedColumns, currentSort });
    this.tableContainer.addEventListener('scroll', throttle(this.handleScroll, 15));
    if (mediaType !== DESKTOP) {
      this.updateWindowDimensions();
      window && window.addEventListener('resize', this.updateWindowDimensions);
    }
    get(this.tableContainer, 'target.scrollLeft') && this.handleScroll(this.tableContainer);
  }

  componentWillReceiveProps = newProps => {
    const allColumns = [];
    let fixedColumns = [];
    if (newProps.colGroups !== this.props.colGroups) {
      const { colGroups } = newProps;
      colGroups.forEach(group => {
        group.columns.forEach(col => allColumns.push(col));
        if (group.fixedColumns !== undefined) {
          group.fixedColumns.map(col => fixedColumns.push(col));
        } else {
          fixedColumns = [...allColumns];
        }
      });
      this.setState({ allColumns, fixedColumns });
    }
    if (newProps.data !== this.props.data) {
      const { initialSortColumn, sortAscending, noRank } = newProps;
      const initialSortDir = sortAscending ? SortTypes.ASC : SortTypes.DESC;
      this.processMatrix(newProps.data, initialSortColumn, initialSortDir);
      get(this.tableContainer, 'target.scrollLeft') && this.handleScroll(this.tableContainer);
    }
  };

  componentWillUnmount = () => {
    window && window.removeEventListener('resize', this.updateWindowDimensions);
    this.tableContainer && this.tableContainer.removeEventListener('scroll', throttle(this.handleScroll, 15));
  }

  componentDidUpdate = () => {
    const scrollLeft = this.tableContainer && this.tableContainer.scrollLeft;
    scrollLeft && this.updateScrollPositions(scrollLeft);
    const { showAnalysis } = this.props;
    this.state.hideMoreContent && !showAnalysis && this.state.hideMoreContent.indexOf(false) > -1 && this.setState({ hideMoreContent: new Array(this.state.hideMoreContent.length).fill(true) });
  }

  updateWindowDimensions = () => {
    window && this.setState({ windowWidth: window.innerWidth });
  }

  addFixedElement = el => {
    el && this.fixedElements.push(el);
  }

  setTableRef = el => {
    this.tableContainer = el;
  }

  handleContentShowup = (index) => {
    var arr = this.state.hideMoreContent;
    arr[index] = false;
    this.setState({ hideMoreContent: arr });
  }

  handleContentHidden = (index) => {
    var arr = this.state.hideMoreContent;
    arr[index] = true;
    this.setState({ hideMoreContent: arr });
  }

  handleScroll = node => {
    /* Experimenting with FastDom for DOM read/write batching. Needs more testing. */
    // const scrollLeft = Number(node.target.scrollLeft.toFixed(1));
    fastdom.measure(() => {
      const scrollLeft = Number(node.target.scrollLeft.toFixed(1));
      const length = this.fixedElements.length;
      for (let i = 0; i < length; i++) {
        let tempElement = this.fixedElements[i].parentElement;
        fastdom.mutate(() => {
          tempElement.style.transform = `translate3d(${scrollLeft}px,0px,5px)`;
          if (tempElement.className.indexOf('fixedContent') === -1) {
            tempElement.style.borderRight = '5px solid rgba(0, 0, 0, 0.1)';
          }
        });
      }
    });
    // requestAnimationFrame(() => {
    //   this.updateScrollPositions(scrollLeft);
    // });
  };

  updateScrollPositions = scrollLeft => {
    const style = {
      transform: `translate3d(${scrollLeft}px,0px,5px)`,
      borderRight: '5px solid rgba(0, 0, 0, 0.1)',
    };
    const length = this.fixedElements.length;
    for (let i = 0; i < length; i++) {
      let tempElement = this.fixedElements[i].parentElement;
      tempElement.className.indexOf('fixedContent') === -1 ?
        Object.assign(tempElement.style, { ...style }) : Object.assign(tempElement.style, { ...{ transform: `translate3d(${scrollLeft}px,0px,5px)` } });
    }
  };

  sortRows = (colKey, dir) => {
    const { allColumns, currentSort, fixedColumns } = this.state;
    const colKeyIndex = allColumns.indexOf(colKey);
    this.setState({ activeCol: colKeyIndex });
    const { matrix } = this.state;
    const rows = matrix[0].rows; // if we're sorting, there's only one element in matrix
    const fixedKey = fixedColumns[colKeyIndex];
    let sortKey = fixedKey === 'player' ? 'lname' : fixedKey === 'Pos' ? 'position' : fixedKey;
    // if it's different direction change the direction of sorting
    if (sortKey === currentSort) {
      dir = dir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
    }
    // Defines the level of search of the sortKey
    if (rows[0] === undefined || rows[0][sortKey] === undefined) {
      sortKey = `stats.${sortKey}`;
    }
    const orderDirection = dir === SortTypes.ASC ? 'asc' : 'desc';
    matrix[0].rows = _.orderBy(rows, [o => get(o, sortKey, -1), 'fpts'], [orderDirection, 'desc']);
    this.setState({ matrix, currentSort: { [colKey]: dir } });
  };

  processRows = batch => {
    const { players } = this.state;
    const rows = batch.map(line => {
      const row = { ...line };
      if (row.id) row.player_id = row.id;
      row.player = `${row.fname} ${row.lname}`;
      players[row.player_id] = row.player;

      if (row.stats) {
        row.stats = row.stats.reduce((stats, stat) => {
          /* eslint-disable no-param-reassign */
          stats[stat.stat_abbr] = (stat.stat_value_total || stat.stat_value_total === 0) ? stat.stat_value_total : stat.stat_value;
          stats[stat.stat_abbr] = stats[stat.stat_abbr] === '-' ? 0 : stats[stat.stat_abbr];
          return stats; /* eslint-enable no-param-reassign */
        }, {});
      } else {
        row.stats = {};
      }

      return row;
    });

    this.setState({ players, hideMoreContent: new Array(rows.length).fill(true) });
    return rows;
  };

  processMatrix = (data, initialSortColumn, initialSortDir) => {
    const { teams } = this.props;
    let { nested } = this.state;

    if (teams && teams.length) {
      nested = true;
      const matrix = data.reduce((finalMatrix, batch) => {
        const game = {
          id: batch.game_id,
          home: teams.find(team => (team.value) === (batch.home_team_id)).key || '',
          away: teams.find(team => (team.value) === (batch.away_team_id)).key || '',
          week: batch.week,
          rows: this.processRows(batch.player_stats),
        };

        finalMatrix.push(game);
        return finalMatrix;
      }, []);

      this.setState({ matrix, nested });
    } else {
      this.setState({ matrix: [{ rows: this.processRows(data) }] },
        () => this.sortRows(initialSortColumn, initialSortDir));
    }
  };

  isSelected = (player_id, team_id) => {
    // Teams have Null for player_id, so without this logic all teams will appear to be selected even if only one team is selected under the DF tab.
    if (player_id) {
      return this.props.selectedPlayers.some(player => player.player_id === player_id);
    } else {
      return this.props.selectedPlayers.some(player => (player.team_id === team_id && player.player_id == null ) );
    }
  }

  renderColGroups = () => {
    const { colGroups } = this.props;

    // In order for titles to show, all groups must use the name prop, even if it is ''
    // If no name prop exists, we can assume this table has no title row
    if (!colGroups.length || typeof colGroups[0].name === 'undefined') { return null; }

    const emptyGroupNames = ['generic', ''];
    const hasGroups = colGroups.some(
      group => !emptyGroupNames.includes(group.name),
    );
    if (!hasGroups) return null;

    return (
      <Table.Header>
        <Table.Row>
          {colGroups.map(group => (
            <Table.HeaderCell
              className="table-title"
              key={group.name}
              colSpan={group.columns.length}
            >
              {group.name === 'generic' ? '' : group.name.toUpperCase()}
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
    );
  };

  renderColumnHeaders = gameData => {
    const { language } = this.props;
    const { allColumns, currentSort, nested } = this.state;
    const week = gameData.week == null ? '' : `(Wk${gameData.week})`
    const game = nested ?
      (<div ref={this.addFixedElement}>
      <span className='teamVteamAway'>
          {gameData.away} @ {gameData.home} {week}
        </span>
      <span className='teamVteamHome'>
          {gameData.home} vs {gameData.away} {week}
        </span>
      </div>) :
      null;

    return (
      <Table.Row>
        {allColumns.map(
          (col, idx) =>
            (nested
              ? this.renderStandardHeader({ col, game, language })
              : this.renderSortHeader({ col, currentSort, language, idx })),
        )}
      </Table.Row>
    );
  };

  renderHeaderName = ({ language, col, game }) => {
    if (col === 'player' && game) return game;

    if (dictionary[language][col] && dictionary[language][col].name) {
      return dictionary[language][col].name;
    }

    if (col === 'bye') return 'Bye';

    return col;
  };

  renderStandardHeader = ({ col, game, language }) => (
    <Table.HeaderCell key={col} className={classes.columnHeader}>
      {this.renderHeaderName({ language, col, game })}
    </Table.HeaderCell>
  );

  renderSortHeader = ({ col, currentSort, language, idx }) => {
    const { fixedColumns } = this.state
    const fixedStatName = fixedColumns[idx]
    return (
      <SortHeader
        key={idx}
        colKey={col}
        onSortChange={this.sortRows}
        sortDir={currentSort[col]}
        initialSortDir={this.props.sortAscending ? SortTypes.ASC : SortTypes.DESC}
        isActive={Object.keys(this.state.currentSort)[0] === col}
        textAlign={col === 'player' ? 'left' : 'center'}
        singleLine
        description={(dictionary[language][fixedStatName] && dictionary[language][fixedStatName].description)}
        addFixedElement={col === 'player' ? this.addFixedElement : (() => {})}
      >
        {this.renderHeaderName({ language, col })}
      </SortHeader>
    )
  }

  renderCellData = (row, col) => {

    if (this.props.noStars && col.includes('CONF') && !isNaN(row.stats[col])) return row.stats[col];
    if (col.includes('CONF') && !isNaN(row.stats[col]) && row.stats[col] === 5) return <div className="stars"><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span></div>;

    if (col.includes('CONF') && !isNaN(row.stats[col]) && row.stats[col] === 4) return <div className="stars"><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-minus">&nbsp;</span></div>;

    if (col.includes('CONF') && !isNaN(row.stats[col]) && row.stats[col] === 3) return <div className="stars"><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-minus">&nbsp;</span><span className="star-minus">&nbsp;</span></div>;

    if (col.includes('CONF') && !isNaN(row.stats[col]) && row.stats[col] === 2) return <div className="stars"><span className="star-plus">&nbsp;</span><span className="star-plus">&nbsp;</span><span className="star-minus">&nbsp;</span><span className="star-minus">&nbsp;</span><span className="star-minus">&nbsp;</span></div>;

    if (col.includes('CONF') && !isNaN(row.stats[col]) && row.stats[col] === 1) return <div className="stars"><span className="star-plus">&nbsp;</span><span className="star-minus">&nbsp;</span><span className="star-minus">&nbsp;</span><span className="star-minus">&nbsp;</span><span className="star-minus">&nbsp;</span></div>;

    if (col.includes('FFPTS') && !isNaN(row.stats[col])) return row.stats[col].toFixed(2); // Fix this.
    if (col.includes('FUML') && !isNaN(row.stats[col])) return row.stats[col] || '';
    if (col === 'Pos' && row.position) return row.position;
    // if (col.includes('FUM') && !isNaN(row.stats[col])) return row.stats[col] || '\u2013';
    if (typeof row.stats[col] !== 'undefined') return row.stats[col];
    if (this.props.showAt && col === 'opponent_team_abbr' && row['opponent_location'] === '@') return '@'+row[col];
    if (typeof row[col] !== 'undefined') return row[col];
    // Blank cells should have an en-dash
    return '\u2013';
  };

  renderBody = rows => {
    const { fixedColumns } = this.state;
    var { hideMoreContent } = this.state;
    var that = this;
    const {
      track,
      compare,
      injury,
      tracking,
      collapsed,
      showAnalysis,
      showRookie,
      showTrackedPlayers,
      selectedLeague,
      mediaType } = this.props;
    const cellClass = classNames({ [classes.collapsed]: collapsed });
    const isDesktop = mediaType === DESKTOP;
    const analysisWidthOffset = mediaType === TABLET ? 295 : 230;

    const rowClass = id => classNames({
      [classes.tracked]: !showTrackedPlayers && tracking[id] && tracking[id].leagues.includes(selectedLeague),

      [classes.noAnalysis]: !showAnalysis,
      [classes.desktopAnalysis]: showAnalysis && mediaType === DESKTOP,
      [classes.mobileAnalysis]: showAnalysis && mediaType !== DESKTOP,

    });

    const getPlayer = row => {
      const { ...player } = row;
      player.writeup ? player.writeup = React.DOM.div({ dangerouslySetInnerHTML: { __html: player.writeup } }) : player.writeup = "Analysis coming soon. Please check back later in the week.";
      delete player.stats;
      return player;
    };

    if (!rows.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan={fixedColumns.length} className={classes.noResults}>
            No data available for the current criteria. Please try adjusting the
            filters above.
          </Table.Cell>
        </Table.Row>
      );
    }

    return (
      rows.map((row, index) =>
      {
        const { ...player } = row;
        return (
          <fØ>
            <Table.Row key={row.player_id} className={`${rowClass(row.player_id)} ${classes.stats}`}>
              {fixedColumns.map(col =>
                {
                  var isActiveCol = this.state.activeCol == fixedColumns.indexOf(col);
                return (// eslint-disable-line no-confusing-arrow
                  <Table.Cell
                    key={col}
                    className={isActiveCol ? classes.activeCell : classes.defaultCell}
                    singleLine
                      // rowSpan={(col === 'player' && showAnalysis && isDesktop) ? 2 : 1}
                    textAlign={col === 'player' ? 'left' : 'center'}
                    verticalAlign={col === 'player' ? 'top' : 'middle'}
                  >
                    {col === 'player'
                        ?
                          <PlayerCell
                            player={getPlayer(row)}
                            rank={index + 1}
                            track={track}
                            compare={compare}
                            injury={injury}
                            checked={this.isSelected(row.player_id)}
                            addFixedElement={this.addFixedElement}
                            showHeadshot={false}
                            noRank={this.props.noRank}
                            showLinks={this.props.showLinks}
                            showRookie={showRookie}
                          />
                        : this.renderCellData(row, col)
                      }
                    </Table.Cell>)
                }
              )}
            </Table.Row>
            <Table.Row className={classes.hidden} />
            <Table.Row className={`${rowClass(row.player_id)} ${classes.analysis}`}>

              {showAnalysis && (
                <Table.Cell verticalAlign={'top'}>
                  <PlayerCell player={getPlayer(row)}
                    addFixedElement={this.addFixedElement}
                    showHeadshot={showAnalysis}
                    noName
                    noRank
                  /></Table.Cell>
              )}

              {showAnalysis &&
              (isDesktop ?
                <Table.Cell colSpan={fixedColumns.length - 1}>
                  <div className={classes.writeupContainer}>
                    {getPlayer(row).writeup || 'No analysis available.'}
                  </div>
                </Table.Cell> :
                <Table.Cell colSpan={fixedColumns.length - 1} className={classes.mobileAnalysis}>
                  <div className={classes.fixedContent} style={{ width: `${this.state.windowWidth - analysisWidthOffset}px` }}>
                  <div ref={this.addFixedElement} className={((player.writeup ?  player.writeup.length > 140 : false)
                        && hideMoreContent[index]) ?
                        classes.hideWriteupConatiner
                      : classes.writeupContainer} style={{ width: `${this.state.windowWidth - analysisWidthOffset}px` }}>
                      {getPlayer(row).writeup || 'No analysis available.'}
                      {(player.writeup ? player.writeup.length > 140 : false) && <div className={classes.hideMoreContent} onClick={that.handleContentHidden.bind(that, index)}>{'less'}</div>}
                    </div>
                    {(player.writeup ? player.writeup.length > 140 : false) && this.state.hideMoreContent[index]
                    && <div className={classes.addMoreContent} onClick={that.handleContentShowup.bind(that, index)}>{'more...'}</div>}
                  </div>
                </Table.Cell>
              )}
            </Table.Row>
          </fØ>
        )
      })
    );
  }

  render() {
    const { showAnalysis, className, mediaType } = this.props;
    const isMobile = mediaType !== DESKTOP;
    const { matrix } = this.state;
    const tableClass = classNames({
      [classes.tableContainer]: true,
      [className]: className,
      scrollable: isMobile,
    });
    return (
      <div
        className={tableClass}
        ref={this.setTableRef}
      >
        <Table
          className="dataTable"
          striped
          celled
          selectable
          unstackable
          structured={showAnalysis}
        >
          {this.renderColGroups()}
          <Table.Body>
            {matrix.map(game => [
              this.renderColumnHeaders(game),
              this.renderBody(game.rows),
            ])}
          </Table.Body>
        </Table>
      </div>
    );
  }
}
export default connect(mapStateToProps, actions)(DataTable);



// WEBPACK FOOTER //
// ./src/app/components/DataTable/DataTable.js